import { routerActions as connectedRouterActions } from 'connected-react-router';
import { Route } from './types';
import { getFullPathForRoute } from './utils';

export const push = (route: Route) =>
  connectedRouterActions.push(getFullPathForRoute(route), route.additionalState);
export const goBack = () => connectedRouterActions.goBack();
